import React from 'react'
import Moment from 'react-moment';
import { CategorylogoStorage_LINK } from '../../api/ApiUrl';
import Avatar from './Avatar';
import { useNavigate } from 'react-router-dom';
import Logo from '../../Logo'


const NotificationBar = ({notification, setShowNotification}) => {

  const navigate = useNavigate();

  const goTo=(link)=>{
    if(link && link.length>3){
      navigate(link)
      setShowNotification(false)
    }
  }

  return (
    <button onClick={()=>goTo(notification.onClickLink)} className="w-full text-left">
    <div className={`group notificationBar ${notification.read? `read` :  `unread`}`}>
        <div className='notificationBar-content'>
          <div className='notificationBar-icon'>
            {notification.iconType==0 &&
              <img src={`${CategorylogoStorage_LINK}${notification.icon}`} alt={'category'}/>
            }
             {notification.iconType==1 &&
            <Avatar value={notification.icon} width='7' height={'7'}/>
             }
              {notification.iconType==3 &&
             <Logo className='notificationBar-logo' fill={"fill-slate-400 dark:fill-slate-500"}/>
             }
          </div>

          
          <div className='notificationBar-copy'>
          <div className='notificationBar-title-row'>
            <p className='notificationBar-title'>{notification.title}</p>
            {!notification.read?<span className='notificationBar-dot'/>:null}
          </div>
          <p className='notificationBar-body'>{notification.body}</p>
         
          {notification.createdAt !=null &&
          <Moment className='notificationBar-time' date={notification.createdAt.toDate()} fromNow/>
          }
          </div>
        </div>
        
    </div>
    </button>
  )
}

export default NotificationBar
